import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import { router } from './router'
import { queryClient } from './api/query-client'
import { i18n } from './i18n'
import { initTheme } from './ui-delta/useTheme'
import './assets/main.css'
import 'nprogress/nprogress.css'

// Reconcile the theme refs with whatever the inline snippet in index.html already
// put on <html>. Runs before mount so nothing renders against a stale value.
initTheme()

createApp(App)
  .use(createPinia())
  .use(router)
  .use(i18n)
  .use(VueQueryPlugin, { queryClient })
  .mount('#app')
